/*
 * This has only been tested on checkboxes, but it should work for radio buttons as well.  The idea is if an option is
 * selected (or checked), then inputs that should be disabled/enabled based on that fact will be updated.
 *
 * For example, bundling product have a checkbox for the componentID and two hidden inputs (bundleGroupID and label).
 * The hidden should be disabled if the checkbox is not checked and enabled if checked.
 *
 * The master input (radio/checkbox) must have data-inputtogglemaster='1' as well as data-inputtoggle='className'.  The
 * class name must be put on the inputs, which is used to disable/enable.
 */
$(document).ready(function(){
    $(document).on('click', "[data-inputtogglemaster='1']", function(){
        inputToggle(this);
    });
    // on load
    $("[data-inputtogglemaster='1']").each(function() {
        inputToggle(this);
    });
});

function inputToggle(master){
    const $master = $(master);
    const className = $master.data('inputtoggle');
    const isChecked = $master.is(":checked");

    // We use .not(master) to ensure the checkbox doesn't disable itself
    $(document).find('.' + className).not($master).prop('disabled', !isChecked);
}